import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { useSubscription } from '@meraki-internal/state';
import { NavigationItemList } from './NavigationItemList';
import { AddCareMapButton } from '../caremap/AddCareMapButton';
import { InviteFriendsButton } from '../referral/InviteFriendsButton';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { Divider } from '../components/Divider';

interface NewUINavigationListProps {
    closeMenuHandler?: () => void;
}

export const NewUINavigationList: React.FC<NewUINavigationListProps> = ({ closeMenuHandler  }) => {
    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    // don't show nav, that would direct user to create a personal caremap
    if (orgState.isOrgTeamMember() && !careMapState.getMostRecentCaremap()){
        return null;
    }

    // Button stays visible for non-anonymous, non-org-team-member users.
    // AddCareMapButton handles its own disabled state during intro processing.
    const showAddButton = !orgState.isOrgTeamMember() && !isAnonymous;

    return (
        <NavigationItemList>
            {showAddButton && (
                <>
                    <div style={{margin: 24}}>
                        <AddCareMapButton
                            trackingFrom="side-menu"
                            closeMenu={() => {
                                if (closeMenuHandler){
                                    closeMenuHandler();
                                }
                            }}
                        />
                    </div>
                    <div style={{margin: '0 24px 24px 24px'}}>
                        <InviteFriendsButton closeMenu={() => {
                            if (closeMenuHandler){
                                closeMenuHandler();
                            }
                        }} />
                    </div>
                    <Divider />
                </>
            )}
        </NavigationItemList>
    );
};
